module.exports = __webpack_public_path__ + "img/foot_WeChat_App.c18aff2e.jpg";